import React from 'react';
import Collapse from 'react-bootstrap/Collapse';
import CourseCard from '../course-card';
import './styles.scss';

const CoursesCollapsibleSheet = ({ courses, onPlayCoursePreview, onEntering, onEntered, onExit, sheetIsExpanded }) => {
  return (
    <Collapse onEntering={onEntering} onEntered={onEntered} onExit={onExit} in={sheetIsExpanded}>
      <div className="courses-collapsible-sheet">
        {courses.map(course => (
          <div key={course.id} className="courses-collapsible-sheet__item">
            <CourseCard course={course} onPlayCoursePreview={onPlayCoursePreview} />
          </div>
        ))}
      </div>
    </Collapse>
  );
};

export default CoursesCollapsibleSheet;
